export default "__VITE_ASSET__cae0ca75__"